import React, { useState } from 'react';
import {AiFillEyeInvisible,AiFillEye} from 'react-icons/ai';
import {Link} from 'react-router-dom';
import OAuth from '../components/OAuth';
import {getAuth ,createUserWithEmailAndPassword ,updateProfile} from 'firebase/auth';
import {db} from '../firebase';
import { serverTimestamp, setDoc,doc } from 'firebase/firestore';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';

const SignUp = () => {

  const [formData,setFormData] = useState({
    name:"",
    email:"",
    password:""
  });
  const [showPassword,setShowPassword] = useState(false);
  const navigate = useNavigate();
  
  const {name,email,password} = formData;

  const onChange = (e) => {


    setFormData((prevState) => (
      {
        ...prevState,
        [e.target.id]:e.target.value
      }
    ))


  }

  const onSubmit = async (e) => {

      e.preventDefault();

      try {
        
        const auth = getAuth();
        const userCredential = await createUserWithEmailAndPassword(auth,email,password);
        const user = userCredential.user;


        updateProfile(auth.currentUser,{
          displayName:name,
        })

        const formDataCopy = {...formData};
        delete formDataCopy.password;
        
        formDataCopy.timestamp = serverTimestamp();

        await setDoc(doc(db,"users",user.uid),formDataCopy);
        navigate("/");


      } catch (error) {

        toast.error("Something went wrong with the registration.")
        
      }
  }


  return (
    <section>
      <h1 className="text-3xl text-center mt-6 font-bold">Sign Up</h1>

      <div className="flex justify-center flex-wrap items-center px-6 py-12 mx-auto max-w-6xl">
        <div className="md:w-[67%] lg:w-[50%] mb-12 md:mb-6">
          <img className="w-full rounded-2xl"  alt="key" src="https://images.unsplash.com/flagged/photo-1564767609342-620cb19b2357?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8a2V5fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60" />
        </div>
        <div className="w-full md:w-[67%] lg:w-[40%] lg:ml-20">
          <form onSubmit={onSubmit}>
          <input id="name" type="text" value={name} onChange={onChange} placeholder="Full Name" className="mb-6 w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"/>
            <input id="email" type="email" value={email} onChange={onChange} placeholder="Email Address" className="mb-6 w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"/>
            <div className="relative mb-6">
            <input id="password" type={showPassword ? "text" : "password"} value={password} onChange={onChange} placeholder="Password" className="w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"/>
            {showPassword ? (<AiFillEyeInvisible className="absolute right-3 top-3 text-xl cursor-pointer" onClick={()=>setShowPassword((prevState)=> !prevState)} />) : (<AiFillEye onClick={()=>setShowPassword((prevState)=> !prevState)} className="absolute right-3 top-3 text-xl cursor-pointer" />)}
            </div>

            <div className="flex justify-between whitespace-nowrap text-sm sm:text-lg">
              <p className="mb-6">Have an account? <Link to="/sign-in" className="text-red-600 hover:text-red-700 transition duration-200 ease-in-out">Sign In</Link> </p>
              <p>
                <Link to="/forgotpassword" className="text-blue-600 hover:text-blue-800 transition duration-200 ease-in-out">Forgot Password?</Link>
              </p>
            </div>
            <button className="w-full bg-blue-600 text-white px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-blue-700 transition duration-150 ease-in-out hover:shadow-lg active:bg-blue-800" type="submit">Sign Up</button>
                <div className="my-4 before:border-t flex before:flex-1  before:border-gray-300 after:border-t after:flex-1 items-center after:border-gray-300">
                <p className="text-center font-semibold mx-4">OR</p>
                </div>
                <OAuth />
          </form>
          
        </div>
      </div>
    </section>
  )
}

export default SignUp